import { COOKIE_KEYS } from 'constants/common'
import Cookies from 'js-cookie'

type BookingDetailsParam = {
  selectedSlot: SelectedSlot
  providerDetails: Provider
  appointmentModeId?: string
  counselingTypeId?: string
}

export const storeBookingDetailsForV2 = ({
  selectedSlot,
  providerDetails,
  appointmentModeId,
  counselingTypeId,
}: BookingDetailsParam): void => {
  Cookies.set(COOKIE_KEYS.PRE_BOOKING_SELECTION, {
    slot: {
      id: selectedSlot.slot.id,
      start: selectedSlot.slot.start,
    },
    providerId: providerDetails.id,
    practiceId: providerDetails.practice.id,
    ...(appointmentModeId ? { appointmentModeId } : null),
    ...(counselingTypeId ? { counselingTypeId } : null),
  })
}

export const getAddressFromRP = (
  patientAddress: PatientAddress | null | undefined
): PatientAddress => {
  return patientAddress
    ? {
        line1: patientAddress.line1 || '',
        line2: patientAddress.line2 || '',
        city: patientAddress.city || '',
        state: patientAddress.state || '',
        zipcode: patientAddress.zipcode || '',
      }
    : {
        line1: '',
        line2: '',
        city: '',
        state: '',
        zipcode: '',
      }
}
